// extracted by mini-css-extract-plugin
module.exports = {"root":"Settings_root__97Rot","search":"Settings_search__3OQPq","filter":"Settings_filter__nFe5R"};